import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { getItem, setItem } from './storage'

export const useLocalStorageState = (name, initialValue) => {
  const [state, setState] = useState(getItem(name, initialValue))

  useEffect(() => {
    setItem(name, state)
  }, [state])

  return [state, setState]
}
